var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavBarCase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.277832,
    width: 48,
    height: 49.2779,
    rx: 16,
    fill: "#1B1C21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1417 17.5093H15.9497C14.0334 17.5093 12.48 19.1676 12.48 21.2132V24.5724L20.3879 27.3863H27.7035L35.6114 24.5724V21.2132C35.6114 19.1676 34.058 17.5093 32.1417 17.5093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7326 17.5091V16.2744H26.3588V17.5091H28.672V16.2744C28.6705 14.9113 27.6357 13.8067 26.3588 13.8052H21.7326C20.4556 13.8067 19.4209 14.9113 19.4194 16.2744V17.5091H21.7326ZM20.3879 27.3861L12.48 24.5722V32.3247C12.4821 34.3693 14.0343 36.0263 15.9497 36.0286H32.1417C34.0571 36.0263 35.6093 34.3693 35.6114 32.3247V24.5722L27.7035 27.3861H20.3879Z",
    fill: "#6C6D76"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarCase);
export default __webpack_public_path__ + "static/media/nav_bar-case.10a21e50.svg";
export { ForwardRef as ReactComponent };